import View from './View';
import CallToActionSchema from './schema';
import icon from '@plone/volto/icons/megaphone.svg';

const CallToActionBlock = {
    id: 'w_call_to_action',
    title: 'Call To Action',
    view: View,
    icon: icon,
    group: 'wildcard',
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    blockSchema: CallToActionSchema,
};

export default CallToActionBlock;